import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import {
  postDetails,
  postMultipartDetails,
} from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import EditorField from "../../components/EditorField/EditorField";
import "./addContentForm.css";
import encrypt from "../../utils/helpers/encrypt";
import { HiArrowSmallLeft } from "react-icons/hi2";
import PageHeader from "../../components/PageHeader/PageHeader";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch } from "../../store/storeRequests";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const AddContentForm: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [numberInput, setNumberInput] = useState<string>("");
  const inputRef = useRef<HTMLInputElement | null>(null);
  const { tranaingId, order } = location.state || {};
  const [imageFile, setImageFile] = useState<File | null>(null);
  const dispatch = useAppDispatch();
  const [selectedModule, setSelectedModule] = useState<string>("Please Select");
  const [mediaType, setMediaType] = useState<string>("Media");
  const [error, setError] = useState<string | null>(null);
  const [file, setFile] = useState<File | null>(null);
  const [content_desc, setContentDesc] = useState<string>("");
  const [link, setLink] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [pollQuestion, setPollQuestion] = useState<string>("");
  const [pollOptions, setPollOptions] = useState<string[]>([""]);
  const [folderData, setFolderData] = useState<
    { id: number; folder_name: string }[]
  >([]);
  const [selectedQuiz, setSelectedQuiz] = useState<number | null>(null);
  const [showResults, setShowResults] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [isValidFile, setIsValidFile] = useState<boolean>(true);

  const fetchQuizOptions = async () => {
    try {
      dispatch(showLoader("Loading data..."));
      const response = await postDetails(APIList.GET_QUIZ_OPTIONS, {});
      if (response.status === 200) {
        setFolderData(response.data);
      } else {
        setFolderData(response.data);
      }
    } catch (err) {
      setError("Error fetching quiz options.");
      console.error("Error fetching quiz options:", err);
    } finally {
      dispatch(hideLoader());
    }
  };

  useEffect(() => {
    if (selectedModule === "Add Quiz") {
      fetchQuizOptions();
    }
  }, [selectedModule]);

  useEffect(() => {
    const preventScroll = (e: WheelEvent) => {
      if (document.activeElement === inputRef.current) {
        e.preventDefault();
      }
    };

    inputRef.current?.addEventListener("wheel", preventScroll);
    return () => {
      inputRef.current?.removeEventListener("wheel", preventScroll);
    };
  }, []);

  const handleInputChanges = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    // Prevent negative numbers and non-numeric values
    if (Number(value) >= 0) {
      setNumberInput(value);
    }
  };

  const handleEditorChange = (event: any, editor: any) => {
    const data = editor.getData();
    updateCharCountAndValidation(data);
    if (charCount <= 500) {
      setContentDesc(data);
    }
  };

  const handleEditorChanges = (event: any, editor: any) => {
    const data = editor.getData();
    updateCharCountAndValidations(data);
    if (charCount <= 2000) {
      setContentDesc(data);
    }
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const uniqueOptions = new Set(pollOptions);

    if (uniqueOptions.size !== pollOptions.length) {
      dispatch(showToast("Same options are not allowed."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }
    if (error) {
      return;
    }

    // if (Number(numberInput) === 0) {
    //   alert("Number cannot be zero.");
    //   return;
    // }
    if (Number(numberInput) <= 0) {
      dispatch(showToast("Order Cannot be 0 or Negative"));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    const formData = new FormData();

    const payload: any = {
      training_id: tranaingId,
      content_type: selectedModule === "Media" ? mediaType : selectedModule,
      // order: order,
    };
    if (selectedModule === "Please Select") {
      // alert("Please select a valid module before submitting the form.");
      return;
    }
    if (
      selectedModule === "Text" &&
      (!content_desc || content_desc.trim().length < 3)
    ) {
      // alert("Description is required and must be at least 3 characters long.");
      return;
    }
    if (
      selectedModule === "Media" &&
      content_desc &&
      content_desc.length > 600
    ) {
      dispatch(showToast("Content description cannot exceed 500 characters."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }
    if (
      selectedModule === "Text" &&
      content_desc &&
      content_desc.length > 2100
    ) {
      dispatch(showToast("Content description cannot exceed 2000 characters."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    if (selectedModule === "Live Poll") {
      if (!pollQuestion || pollQuestion.trim().length === 0) {
        // alert("Poll question is required.");
        return;
      }

      const filledOptions = pollOptions.filter(
        (option) => option.trim().length > 0
      );
      if (filledOptions.length < 1) {
        // alert("At least one poll option is required.");
        return;
      }
      const filledOptionss = pollOptions.filter(
        (option) => option.trim().length > 0
      );

      if (filledOptionss.length < 2) {
        dispatch(showToast("At least two poll options are required."));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }
    }

    if (selectedModule === "Media" && file) {
      payload.content_desc = content_desc;
      payload.content_name = file.name;
      payload.order = Number(numberInput);

      if (file) {
        formData.append("content_name", file);
      }
    }
    // if (selectedModule === "Media" && file) {
    //   const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf',  'audio/mp3', 'video/mp4'];

    //   if (!allowedFileTypes.includes(file.type)) {
    //     alert("Invalid file type. Only JPG, JPEG, PNG, PDF, MP4, and MP3 are allowed.");

    //     return;
    //   }

    //   payload.content_desc = content_desc;
    //   payload.content_name = file.name;

    //   formData.append('content_name', file);
    // }

    if (selectedModule === "Links") {
      payload.content_type = "Survey";
      payload.content_name = title;
      payload.link = link;
      payload.content_desc = "";
      payload.order = Number(numberInput);
    }

    if (selectedModule === "Live Poll") {
      payload.content_type = "Poll";
      payload.content_name = pollQuestion;
      payload.pollOptions = pollOptions;
      payload.show_result = showResults ? 1 : 0;
      payload.order = Number(numberInput);
    }

    if (selectedModule === "Add Quiz") {
      const selectedFolder = folderData.find(
        (folder) => folder.id === selectedQuiz
      );
      if (selectedFolder) {
        payload.content_type = "Quiz";
        payload.folder_id = selectedFolder.id;
        payload.order = Number(numberInput);

        // payload.show_result = showResults ? 1 : 0;
        // payload.show_result =0;
      } else {
        setError("Please select a valid quiz.");
        return;
      }
    }

    if (selectedModule === "Text") {
      payload.content_desc = content_desc;
      payload.order = Number(numberInput);
    }

    formData.append("data", encrypt(payload));

    try {
      if (!tranaingId) {
        setError("Training ID is missing.");
        return;
      }
      dispatch(showLoader("Loading data..."));
      const response = await postMultipartDetails(
        APIList.ADD_TRAINING_CONTENT,
        formData
      );
      console.log("Add Content Response:", response);

      if (response.status === 200) {
        setSelectedModule("Please Select");
        setMediaType("Please Select");
        setFile(null);
        setContentDesc("");
        setLink("");
        setTitle("");
        setPollQuestion("");
        setPollOptions([""]);
        setSelectedQuiz(null);

        dispatch(showToast("Successfully Added"));
        setTimeout(() => dispatch(hideToast()), 3000);
      } else {
        navigate(`/training/view/${tranaingId}`);
      }

      if (response.status === "Failed") {
        dispatch(showToast("Please fill Form Properly."));
        setTimeout(() => dispatch(hideToast()), 3000);
      }
      if (response.message === "Data already present") {
        dispatch(
          showToast(
            "While adding you cannot enter the same order which is already present"
          )
        );
        setTimeout(() => dispatch(hideToast()), 3000);
      }
    } catch (err) {
      setError("Failed to add content.");
      dispatch(showToast("Failed to add content."));
      setTimeout(() => dispatch(hideToast()), 3000);
      console.error("Error adding content:", err);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleShowResultsToggle = (e: any) => {
    setShowResults(e.target.checked);
  };
  const stripHtmlTags = (html: string) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const updateCharCountAndValidation = (data: any) => {
    const plainText = stripHtmlTags(data);
    const charLength = plainText.length;

    if (charLength > 500) {
      setError("Character limit exceeded (500 max)");

      // dispatch(showToast("Character limit exceeded (500 max)"));
      // setTimeout(() => dispatch(hideToast()), 3000);
    } else {
      setError("");
    }

    setCharCount(charLength);
  };
  const updateCharCountAndValidations = (data: any) => {
    const plainText = stripHtmlTags(data);
    const charLength = plainText.length;

    if (charLength > 2000) {
      setError("Character limit exceeded (2000 max)");
      //     setError("Character limit exceeded (2000 max)");

      // dispatch(showToast("Character limit exceeded (2000 max)"));
      // setTimeout(() => dispatch(hideToast()), 3000);
    } else {
      setError("");
    }

    setCharCount(charLength);
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const values = e.target.value;

    if (name === "content_desc") {
      setContentDesc(value);
    } else if (name === "link") {
      setLink(value);
    } else if (name === "title") {
      setTitle(value);
    } else if (name === "pollQuestion") {
      setPollQuestion(value);
    }
  };

  // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.files) {
  //     setFile(e.target.files[0]);
  //   }
  // };
  // const handleEditorChange = (event:any, editor:any) => {
  //   const data = editor.getData();
  // };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    setFile(file);
    setError("");

    if (file) {
      console.log("Selected file:", file);

      const allowedFileTypes = [
        "image/jpeg",
        "audio/mpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
        "video/mp4",
      ];

      const disallowedExtensions = ["jfif"];

      const fileExtension = file.name.split(".").pop()?.toLowerCase();
      const fileSizeMB = file.size / (1024 * 1024);

      const sizeLimits = {
        // image: 10.5,
        // audio: 20,
        // pdf: 20,
        // video: 25,
      };

      if (
        !allowedFileTypes.includes(file.type) ||
        (fileExtension && disallowedExtensions.includes(fileExtension))
      ) {
        setError(
          "Invalid file type. Only JPG, JPEG, PNG, PDF, MP4, and MP3 are allowed."
        );
        setFile(null);
        setIsValidFile(false);
        return;
      }

      // if (file.type.startsWith("image/") && fileSizeMB > sizeLimits.image) {
      //   setError("Image files must be smaller than 10MB.");
      //   setFile(null);
      //   setIsValidFile(false);
      //   return;
      // }

      // if (
      //   (file.type === "audio/mpeg" || file.type === "application/pdf") &&
      //   fileSizeMB > sizeLimits.audio
      // ) {
      //   setError("Audio and PDF files must be smaller than 20MB.");
      //   setFile(null);
      //   setIsValidFile(false);
      //   return;
      // }

      // if (file.type.startsWith("video/") && fileSizeMB > sizeLimits.video) {
      //   setError("Video files must be smaller than 25MB.");
      //   setFile(null);
      //   setIsValidFile(false);
      //   return;
      // }

      setIsValidFile(true);
    }
  };

  const isButtonDisabled = selectedModule === "Media" && !file;

  const handleAddOption = () => {
    setPollOptions([...pollOptions, ""]);
  };

  const handleOptionChange = (index: number, value: string) => {
    const updatedOptions = [...pollOptions];
    updatedOptions[index] = value;
    setPollOptions(updatedOptions);
  };

  const handleRemoveOption = (index: number) => {
    setPollOptions(pollOptions.filter((_, i) => i !== index));
  };
  const buttons = [
    {
      label: "Back to Content",
      theme: "danger",
      icon: <HiArrowSmallLeft />,
      onClick: () => navigate(`/training/view/${tranaingId}`),
    },
  ];
  return (
    <LayoutContainer title={"Add Content"}>
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-list"></i>
          Add New Content
        </h2>

        <PageHeader buttons={buttons} />
      </div>
      {/* <h2>Add New Content</h2> */}

      {/* {error && <div className="alert alert-danger">{error}</div>} */}

      <Form className="add-conect-form" onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Label className="header-add-content">
            Select Module to Add
          </Form.Label>
          <Form.Control
            className="please-select-content"
            name="contentDropdowns"
            as="select"
            value={selectedModule}
            onChange={(e) => setSelectedModule(e.target.value)}
            required
          >
            <option value="Please Select">Please Select</option>
            <option value="Media">Media</option>
            <option value="Add Quiz">Add Quiz</option>
            <option value="Live Poll">Live Poll</option>
            <option value="Text">Text</option>
            <option value="Links">Links</option>
          </Form.Control>
        </Form.Group>

        {selectedModule === "Media" && (
          <>
            {/* <Form.Group className="media-select">
              <Form.Label className="header-add-content">Select Media Type</Form.Label>
              <Form.Control
                className="please-select-content"
                as="select"
                value={mediaType}
                name="contentDropdown"
                onChange={(e) => setMediaType(e.target.value)}
                required
              >
                <option value="Please Select">Please Select</option>
                <option value="Video">Video</option>
                <option value="Image">Image</option>
                <option value="Audio">Audio</option>
                <option value="PDF">PDF</option>
              </Form.Control>
            </Form.Group> */}
            <Form.Group className="media-select">
              <Form.Label className="header-add-content">
                Upload File
              </Form.Label>
              <Form.Control
                name="contentDropdown"
                type="file"
                accept=".mp3, .mp4, .jpg, .jpeg, .png, .pdf"
                onChange={handleFileChange}
                required
              />
            </Form.Group>
            <CKEditor
              editor={ClassicEditor as any}
              data={content_desc}
              onChange={handleEditorChange}
              config={{
                placeholder: "Enter Description",
                // minLength: 3,
                // maxLength: 500
              }}
            />

            <div className="character-count text-end">
              {charCount}/{500}
            </div>
            {error && (
              <div style={{ color: "red", marginTop: "2px" }}>{error}</div>
            )}
            {/* <EditorField
    className="word-box"
    name="content_desc"
    label="Description"
    type="text"
    value={content_desc} 
    placeholder="Enter Description"
    minLength={3}
    maxLength={500}
    required={true}
    onChangeInput={handleInputChange} 
  /> */}
            {/* <div className="character-coun">
    {content_desc.length-7}/{500} 
  </div> */}
            <Form.Group className="number-input">
              <Form.Label className="header-add-content">
                Enter Order
              </Form.Label>
              <Form.Control
                type="number"
                value={numberInput}
                onChange={(e: any) => setNumberInput(e.target.value)}
                placeholder="Enter a number"
                max={99}
                onWheel={(e: any) => e.target.blur()}
                required
              />
            </Form.Group>
          </>
        )}

        {selectedModule === "Text" && (
          <>
            <CKEditor
              editor={ClassicEditor as any}
              data={content_desc}
              onChange={handleEditorChanges}
            />
            <div className="character-count text-end">
              {charCount}/{2000}
            </div>
            {error && (
              <div style={{ color: "red", marginTop: "2px" }}>{error}</div>
            )}
            <Form.Group className="number-input">
              <Form.Label className="header-add-content">
                Enter Order
              </Form.Label>
              <Form.Control
                type="number"
                value={numberInput}
                onChange={(e: any) => setNumberInput(e.target.value)}
                placeholder="Enter a number"
                required
                max={99}
                onWheel={(e: any) => e.target.blur()}
              />
            </Form.Group>
          </>
        )}

        {selectedModule === "Links" && (
          <>
            <Form.Group>
              <Form.Label className="header-add-content">Link</Form.Label>
              <Form.Control
                type="url"
                name="link"
                value={link}
                onChange={handleInputChange}
                placeholder="Enter Link"
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label className="header-add-content">Title</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={title}
                onChange={handleInputChange}
                placeholder="Enter Title"
                required
              />
              <Form.Group className="number-input">
                <Form.Label className="header-add-content">
                  Enter Order
                </Form.Label>
                <Form.Control
                  type="number"
                  value={numberInput}
                  onChange={(e: any) => setNumberInput(e.target.value)}
                  placeholder="Enter a number"
                  max={99}
                  onWheel={(e: any) => e.target.blur()}
                  required
                />
              </Form.Group>
            </Form.Group>
          </>
        )}

        {selectedModule === "Live Poll" && (
          <>
            <Form.Group controlId="showResults" className="mt-3">
              <Form.Check
                type="checkbox"
                label="Show Results"
                checked={showResults}
                onChange={handleShowResultsToggle}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label className="header-add-content">
                Poll Question
              </Form.Label>
              {/* <Form.Control
        type="text"
        name="pollQuestion"
        value={pollQuestion}
        onChange={handleInputChange}
        placeholder="Enter Poll Question"
        maxLength={500} 
        required
      /> */}
              <div>
                <textarea
                  name="pollQuestion"
                  value={pollQuestion}
                  placeholder="Enter Poll Question"
                  maxLength={500}
                  required={true}
                  onChange={(e) => handleInputChange(e)}
                  rows={3}
                  className="poll-box"
                />
              </div>
              <Form.Text className="text-muted">
                {pollQuestion.length}/500
              </Form.Text>
            </Form.Group>

            <Form.Label className="header-add-content">Poll Options</Form.Label>
            {pollOptions.map((option, index) => (
              <div key={index} className="d-flex mb-2">
                <Form.Control
                  type="text"
                  placeholder={`Option ${index + 1}`}
                  value={option}
                  onChange={(e) => handleOptionChange(index, e.target.value)}
                  maxLength={100}
                  required
                />
                <Form.Text className="text-muted">
                  {option.length}/100
                </Form.Text>
                <Button
                  variant="danger"
                  onClick={() => handleRemoveOption(index)}
                  className="ml-2"
                >
                  Remove
                </Button>
              </div>
            ))}

            <button className="add-options" onClick={handleAddOption}>
              Add Option
            </button>

            <Form.Group className="number-input">
              <Form.Label className="header-add-content">
                Enter Order
              </Form.Label>
              <Form.Control
                type="number"
                value={numberInput}
                onChange={(e: any) => setNumberInput(e.target.value)}
                max={99}
                placeholder="Enter a number"
                onWheel={(e: any) => e.target.blur()}
                required
              />
            </Form.Group>
          </>
        )}

        {selectedModule === "Add Quiz" && (
          <>
            <Form.Group>
              <Form.Label className="header-add-content">
                Select Quiz
              </Form.Label>
              <Form.Control
                as="select"
                value={selectedQuiz !== null ? selectedQuiz.toString() : ""}
                onChange={(e) => setSelectedQuiz(Number(e.target.value))}
                required
              >
                <option value="">Select a Quiz</option>
                {folderData.map((quiz) => (
                  <option key={quiz.id} value={quiz.id}>
                    {quiz.folder_name}
                  </option>
                ))}
              </Form.Control>
              <Form.Group controlId="showResults" className="mt-3">
                {/* <Form.Check 
        type="checkbox" 
        label="Show Results" 
        checked={showResults} 
        onChange={handleShowResultsToggle} 
      /> */}
                <Form.Group className="number-input">
                  <Form.Label className="header-add-content">
                    Enter Order
                  </Form.Label>
                  <Form.Control
                    ref={inputRef}
                    type="number"
                    value={numberInput}
                    onChange={handleInputChanges}
                    placeholder="Enter a number"
                    max={99}
                    onWheel={(e: any) => e.target.blur()}
                    required
                  />
                </Form.Group>
              </Form.Group>
            </Form.Group>
          </>
        )}
        <div className="d-flex justify-content-center">
          <Button
            className="d-flex justify-content-center mt-2"
            variant="warning"
            type="submit"
            disabled={!!error}
          >
            Add Content
          </Button>
        </div>
      </Form>
    </LayoutContainer>
  );
};

export default AddContentForm;
